<!-- section template -->
<template>
  <Layout :class="[$style.layout, $style[`isStyle${formatTextUpperCasefirst(type)}`]]">
    <BaseBannerJtails title="會員中心" :image="require(`@assets/images/${$globalProjectName}/member/banner@2.jpg`)" />
    <section class="section layout__section">
      <div class="container">
        <BaseButton class="isText mb-4 d-md-none" @click="goBack"> <i class="fal fa-chevron-left"></i> 返回 </BaseButton>
        <div class="row">
          <div class="col-3 d-none d-md-block">
            <SideMenu class="layout__sideMenu" :menu-list="menuList" />
          </div>
          <div class="col-md-9">
            <div class="layout__header">
              <div>
                <h2 v-if="title" class="layout__title">
                  {{ title }}
                </h2>
              </div>
              <div>
                <slot name="header-right" />
              </div>
            </div>
            <slot />
          </div>
        </div>
      </div>
    </section>
  </Layout>
</template>

<script>
import formatTextUpperCasefirst from '@utils/format-text-upper-casefirst'
import { conditionList } from '@utils/is-condition'
import { merchantComputed } from '@store/helpers'

export default {
  components: {
    Layout: () => import('@layout/main'),
    SideMenu: () => import('./Index/SideMenu'),
  },
  props: {
    title: {
      type: String,
      default: '',
    },
    type: {
      type: String,
      default: 'list',
      validator(value) {
        return ['list', 'item'].includes(value)
      },
    },
  },
  data() {
    return {}
  },
  computed: {
    ...merchantComputed,

    menuList() {
      return conditionList([
        {
          title: '會員設定',
          icon: 'user',
          to: {
            name: 'member-info',
          },
        },
        {
          title: '預約/商品記錄',
          icon: 'appointment',
          to: {
            name: 'member-reservation',
          },
        },
        {
          title: this.currentMerchant?.prepaidSetting?.title || this.$t('PREPAID_TITLE'),
          icon: 'plan',
          to: {
            name: 'member-prepaid',
          },
        },
        {
          title: '儲值金',
          icon: 'fal fa-usd-circle',
          isFontAwesome: true,
          to: {
            name: 'member-deposit',
          },
          condition: () => {
            return this.hasDepositModule
          },
        },
        {
          title: `${this.$t('site.USER')}資料`,
          icon: this.$globalIsDingBeauty ? 'db-lipstick' : 'paw',
          to: {
            name: 'member-pet',
          },
        },
        {
          title: '登出',
          icon: 'sign-out',
          type: 'logout',
        },
      ])
    },
  },
  methods: {
    formatTextUpperCasefirst,
    goBack() {
      this.$router.go(-1)
    },
  },
}
</script>

<!-- section style -->
<style lang="scss" module>
.layout {
  :global {
    .layout {
      &__title {
        font-family: $font-title;
        font-size: 1.5rem;
        font-weight: 500;
        letter-spacing: 0.3rem;

        @include max-md {
          margin-bottom: 1rem;
          font-size: 1rem;
          text-align: center;
        }
      }

      &__section {
        @include max-md {
          min-height: calc((var(--vh, 1vh) * 100) - 443px);
          padding-top: 1.5rem;
        }
      }

      &__header {
        display: flex;
        align-items: center;
        justify-content: space-between;
        margin-bottom: 2rem;

        @include max-md {
          display: flex;
          flex-direction: column;
          margin-bottom: 1rem;
          div {
            width: 100%;
          }
        }
      }
    }
  }

  &.isStyleItem {
    :global {
      .layout {
        &__header {
          @include max-md {
            align-items: flex-start;
          }
        }

        &__title {
          @include max-md {
            margin-bottom: 0.5rem;
            font-size: 1.125rem;
            // text-align: left;
          }
        }
      }
    }
  }

  &.isStyleList {
    :global {
      @include unstyled;
    }
  }
}
</style>
